/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Directory_External_Directories_Cta_DescriptionInputs */

const en_directory_external_directories_cta_description = /** @type {(inputs: Directory_External_Directories_Cta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Submit once and go live on ${i?.app} today — then take the catalog from the top. Want done-for-you distribution across these sites? Talk to us.`)
};

const zh_directory_external_directories_cta_description = /** @type {(inputs: Directory_External_Directories_Cta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`一次提交，当天上线 ${i?.app}——再按 DR 从高到低逐站推进。想让编辑代提交这些目录？联系我们。`)
};

/**
* | output |
* | --- |
* | "Submit once and go live on {app} today — then take the catalog from the top. Want done-for-you distribution across these sites? Talk to us." |
*
* @param {Directory_External_Directories_Cta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_cta_description = /** @type {((inputs: Directory_External_Directories_Cta_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Cta_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_cta_description(inputs)
	return zh_directory_external_directories_cta_description(inputs)
});
export { directory_external_directories_cta_description as "directory.external_directories.cta.description" }